import { combineReducers } from 'redux';

import app from './app.reducer';
import { persistData } from './persist.reducer';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const rootReducer = combineReducers({
  app,
  persistData
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['persistData']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default persistedReducer;
